/*
**	Utility functions for making the WFMT Search Bar, which uses
**	Google Search, work dynamically.
**  by Nate Beversluis, 2020
*/


function setupSearchBar() {
	
    /*
    ** Targets the THEMECO search bar and prevents default behavior,
    ** delegating instead to dynamic search using SearchGoogle();
    */

    jQuery('.x-search').submit( function (e) {
           e.preventDefault();
           var searchTerm = jQuery('.x-search-input:visible').val();				
           SearchGoogle(searchTerm, false);
      });

}

function SearchGoogle(searchTerm, backButton) {

   if ( ! jQuery('.search-results-container').length) {
       jQuery('.x-main.left').html(`<h1 class="entry-title">Search Results</h1>
           <div class="search-results-container">
           <script async src="https://cse.google.com/cse.js?cx=2a37c073183b7bed2"></script>
           <div class="gcse-searchbox"></div>
           <div class="gcse-searchresults" data-queryParameterName="s"></div></div>`);
   }
   var currentURL = window.location.href;
   
   if ( jQuery('.gsc-input input').length ) {
       jQuery('.gsc-input input').val(searchTerm);
       jQuery('.gsc-search-button').click();
       if ( ! backButton) {	
           window.history.pushState({'prevURL': '/?s='+searchTerm}, null, currentURL);
       }
   }
   else {
       setTimeout(function () {  SearchGoogle(searchTerm, backButton) }, 500);
   }
}

export { setupSearchBar }